import  { useContext, useState } from "react";
import Slider from "@material-ui/core/Slider";
import { Colour, FontType, Tsize, View, Aos, Controls, Hindit, Repeat, Mode, Header } from "../global";
import { useHistory } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import {
 IonLabel,
 IonToolbar,
 IonButton,
 IonButtons,
 IonItem,
 IonRadioGroup,
 IonRadio,
 IonItemDivider,
 IonCheckbox,
 IonPage,
 IonHeader,
 IonContent,
 isPlatform,
 IonSpinner,
 IonCard,
 IonCardContent
} from "@ionic/react";
import { ArrowBackSharp } from "@mui/icons-material";
import ScrollToTop from "../scroll";
import Drive from "../utils/drive";
function Settings() {
 const useStyles = makeStyles({
  slider: {
   margin: "10px 10px 10px 10px",
   zIndex: 101,
   width: isPlatform("desktop") ? "99%" : "95%",
  },
 });
 const classes = useStyles();
 const [font, setFont] = useContext(FontType);
 let fon;
 if (!font) fon = "Calibri, sans-serif";
 else fon = "Times New Roman, serif";

 const [tsize, setTize] = useContext(Tsize);
 let history = useHistory();

 const handleSliderChange = (event, newValue) => {
  setTize(newValue);
 };
 const [view, setView] = useContext(View);
 const [clr, setClr] = useContext(Colour);
 const [aos, setAos] = useContext(Aos);
 const [controls, setControls] = useContext(Controls);
 const [repeat, setRepeat] = useContext(Repeat);
 const [hindit, setHindi] = useContext(Hindit);
 const [mode, setMode] = useContext(Mode);
 const [header, setHeader] = useContext(Header);
 const [alertsMap, setAlertsMap] = useState({
  fetching: false,
  save: false,
  load: false,
  daily: false
 })

 let color, color2, color3, colori, colorh;
 if(clr === "1") {
    color = "black";
    color2 = "#00CBFE";
    color3 = "white"
    colori = ""
    colorh = "primary"
   }
   if(clr === "2") {
    color = "black";
    color2 = "#FFE34D";
    color3 = "black"
    colori = "secondary"
    colorh = "warning"
   }
   if(clr === "3") {
    color = "black";
    color2 = "#FFA500";
    color3 = "black"
    colori = "secondary"
    colorh = "success"
   }
   if(clr === "4") {
    color = "black";
    color2 = "#87CEEB";
    color3 = "black"
    colori = "secondary"
    colorh = "tertiary"
   }
   if(clr === "5") {
    color = "white";
    color2 = "#FFE34D";
    color3 = "black"
    colori = "dark"
    colorh = "warning"
   }
   if(clr === "6") {
    color = "white";
    color2 = "#87CEEB";
    color3 = "black"
    colori = "dark"
    colorh = "tertiary"
   }


 return (
  <IonPage>
    {alertsMap['fetching'] ? (
     <div
      style={{
       position: 'absolute',
       top: 0,
       left: 0,
       height: '100vh',
       width: '100%',
       zIndex: 10000000,
       display: 'flex',
       justifyContent: 'center',
       alignItems: 'center',
       backgroundColor: 'black',
       opacity: '0.5',
      }}
     >
      <IonSpinner style={{ zIndex: 11, color: 'white' }} />
     </div>
    ) : null}
   <ScrollToTop />
   <IonHeader>
   <IonToolbar  color={colorh}>
    <IonButtons slot="start" onClick={() => {
        if(history.length > 1){
          history.goBack()
        }else{
          history.push("/home");
        }
    }}>
     <IonButton>
     <ArrowBackSharp style={{ fontSize: 30 }} />
     </IonButton>
    </IonButtons>
    <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "सेटिंग" : "Settings"}</IonLabel>
   </IonToolbar>
   </IonHeader>
   <IonContent color={colori} scrollEvents={true}>
   <div style={{ height: "2px" }}></div>
   <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
    <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "फ़ॉन्ट आकार" : "Font Size of the Songs"}</IonLabel>
   </IonItemDivider>
   <div style={{ width: "99%", margin: 0, padding: 0 }}>
    <Slider
     className={classes.slider}
     value={tsize}
     onChange={handleSliderChange}
     aria-labelledby="continuous-slider"
     min={8}
     max={32}
     valueLabelDisplay="on"
    />
   </div>

   <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
    <IonLabel style={{ fontFamily: `${fon}` }}>Language / भाषा</IonLabel>
   </IonItemDivider>
   <IonRadioGroup
    value={hindit}
    onIonChange={(e) => {
     setHindi(e.detail.value);
     if (view === "3") setView("1");
    }}
   >
    <IonItem color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="" >English</IonRadio>
    </IonItem>

    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="1">हिन्दी</IonRadio> 
    </IonItem>
   </IonRadioGroup>
   <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
    <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "थीम" : "Theme of the App"} </IonLabel>
   </IonItemDivider>
   <IonRadioGroup
    value={clr}
    onIonChange={(e) => {
     setClr(e.detail.value);
    }}
   >
    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="1">{hindit ? "निताई / बलराम" : "Nitai / Balarama"}</IonRadio>
    </IonItem>

    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="2">{hindit ? "निमाई" : "Nimai"}</IonRadio>
    </IonItem>

    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="3">{hindit ? "चैतन्य महाप्रभु" : "Caitanya Mahaprabhu"}</IonRadio>
    </IonItem>

    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="4">{hindit ? "राधारानी" : "Radharani"}</IonRadio>
    </IonItem>

    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="5">{hindit ? "कृष्ण" : "Krishna"}</IonRadio>
    </IonItem>

    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="6">{hindit ? "राधा श्यामसुंदर" : "Radha Shyamsundar"}</IonRadio>
    </IonItem>
   </IonRadioGroup>

   <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
    <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "गाने के लिए डिफ़ॉल्ट व्यू" : "Default View for the Songs"}</IonLabel>
   </IonItemDivider>
   <IonRadioGroup value={view} onIonChange={(e) => setView(e.detail.value)}>
    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="1">{hindit ? "प्रत्येक गद्य के बाद अनुवाद" : "Translation after each verse"}</IonRadio>
    </IonItem>

    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="2">{hindit ? "गीत के बाद अनुवाद" : "Translation after the song"}</IonRadio>
    </IonItem>

    {hindit ? null : (
     <IonItem  color={colori}>
      <IonRadio style={{ fontFamily: `${fon}` }} value="3">Word to Word Meanings</IonRadio>
     </IonItem>
    )}
   </IonRadioGroup>
   {hindit ? null : (
    <>
     <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
      <IonLabel style={{ fontFamily: `${fon}` }}>Font Type of the App</IonLabel>
     </IonItemDivider>

     <IonRadioGroup value={font} onIonChange={(e) => setFont(e.detail.value)}>
      <IonItem  color={colori}>
       <IonRadio style={{ fontFamily: `${fon}` }} value="">General Font</IonRadio>
      </IonItem>

      <IonItem  color={colori}>
       <IonRadio style={{ fontFamily: `${fon}` }} value="ved">Vedabase Font</IonRadio>
      </IonItem>
     </IonRadioGroup>
    </>
   )}

   <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
    <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "अन्य सेटिंग" : "Other Settings"}</IonLabel>
   </IonItemDivider>
   {!(isPlatform("desktop") || isPlatform("mobileweb")) ? <IonItem  color={colori}>
    <IonCheckbox style={{ fontFamily: `${fon}` }} checked={aos !== "false"} onIonChange={(e) => setAos(e.detail.checked ? "true" : "false")} >
    {hindit ? "गाने के स्क्रीन को खुला रखें" : "Keep the song screen awake"}
    </IonCheckbox>
   </IonItem>: null}
   <IonItem  color={colori}>
    <IonCheckbox style={{ fontFamily: `${fon}` }} checked={repeat !== "no"} onIonChange={(e) => setRepeat(e.detail.checked ? "yes" : "no")} >
    {hindit ? "ऑडियो दोहराएं" : "Repeat the audio"}
    </IonCheckbox>
   </IonItem>
   <IonItem  color={colori}>
    <IonCheckbox style={{ fontFamily: `${fon}` }} checked={controls !== "false"} onIonChange={(e) => setControls(e.detail.checked ? "true" : "false")} >
    {hindit ? "मिनिमाइज़ म्यूजिक कंट्रोल" : "Minimize music controls"}
    </IonCheckbox>
   </IonItem>
   {!(isPlatform("ios")  && !isPlatform("mobileweb")) ? <IonItem  color={colori}>
    <IonCheckbox style={{ fontFamily: `${fon}` }} checked={header !== "false"} onIonChange={(e) => setHeader(e.detail.checked ? "true" : "false")} >
    {hindit ? "फिक्स्ड हेडर" : "Fixed Header"}
    </IonCheckbox>
   </IonItem> : null}
   <IonItem  color={colori}>
    <IonCheckbox style={{ fontFamily: `${fon}` }} checked={mode !== (isPlatform("ios") ? "md" : "ios")} onIonChange={(e) => {setMode(e.detail.checked ? (isPlatform("ios") ? "ios" : "md") : (isPlatform("ios") ? "md" : "ios"));  window.location.reload(true)}} >
    {hindit ? "डिफ़ॉल्ट डिजाइन" : "Default Design"}
    </IonCheckbox>
   </IonItem>

   <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}`}}>
   <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "बैकअप: बुकमार्क्स और गानों का हिस्ट्री" : "Backup: Bookamrks & Songs History"}</IonLabel>
     </IonItemDivider>
   
   <div style={{ margin: '15px 10px 10px 10px' }}>
      <Drive alertsMap={alertsMap} setAlertsMap={setAlertsMap} colori={colori} fon={fon} hindit={hindit} />
    </div>

    <IonCard color={colori} style={{ color: `${color}`, fontFamily: `${fon}`  }}>
      <IonCardContent>
       {!hindit ? <>
     <p>
     Back up your bookmarks and songs history to Google Drive. This ensures that if you lose your phone, switch to a new one, or if the data gets cleared unknowingly, your data remains safe. You can restore your data anytime by clicking on the RESTORE button.
     </p>
     </> :  <>
     <p>
     अपने बुकमार्क्स और गानों का हिस्ट्री Google Drive पर बैकअप करें। यह सुनिश्चित करेगा कि अगर आप अपना फोन खो दें, नए फोन में स्विच करें, या अज्ञात रूप से डेटा हट जाए, तो आपका डेटा सुरक्षित रहे। आप किसी भी समय "रिस्टोर" बटन पर क्लिक करके अपने डेटा को पुनः स्थापित कर सकते हैं।
     </p>
     </>}
      </IonCardContent>
     </IonCard>

   </IonContent>

  </IonPage>
 );
}

export default Settings;
